import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { catchError, finalize, tap, exhaustMap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TableService, TableResponseModel, ITableState, BaseModel, PaginatorState, SortState, GroupingState } from '../../_metronic/shared/crud-table';
import { Document } from '../_models/document.model';
import { baseFilter } from '../../_fake/fake-helpers/http-extenstions';
import { first } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends TableService<Document> implements OnDestroy {

  apiUrls = {
    getPolicyDocuments : `${environment.url}/${environment.apiUrl}/Producer/get_polizas_documentos?`,
    getDocument : `${environment.url}/${environment.apiUrl}/Producer/get_buscar_documento_poliza?`,
    uploadDocument: `${environment.url}/${environment.apiUrl}/Generico/post_cargar_documento_poliza?`,
    getPolicyEstatement: `${environment.url}/${environment.apiUrl}/Producer/get_estado_cuenta?`,
    getPolicyGeneralCondition: `${environment.url}/${environment.apiUrl}/Producer/get_descargar_generales_poliza?`,
    
  }
  //API_URL = `${environment.url}/${environment.apiUrl}/Producer/get_polizas_documentos`;
  API_URL = `${environment.url}/${environment.apiUrl}/Producer/get_polizas_documentos`;
  constructor(@Inject(HttpClient) http, private auth: AuthService) {
    super(http);
  }


   // READ
  find(tableState: ITableState): Observable<TableResponseModel<Document>> {
    return this.http.get<Document[]>(this.apiUrls.getPolicyDocuments + tableState.paramsGet, {headers: this.auth.httpHeaders}).pipe(
      map((response: Document[]) => {
        const filteredResult = baseFilter(response, tableState);
        const result: TableResponseModel<Document> = {
          items: filteredResult.items,
          total: filteredResult.total
        };
        return result;
      })
    );
  }

  // READ
  async get_documents_by(paramsGet: string) {
    var response = await this.http.get<Document>(this.apiUrls.getDocument + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response[0].Documento != 'undefined') {
      return response[0].Documento;
    }
  }

  async upploadDocument(paramsGet: string)
  {
    
  }

  async getPolicyEstatement(paramsGet: string) {
    var response = await this.http.get<Document>(this.apiUrls.getPolicyEstatement + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
  }

  async getPolicyGeneralCondition(paramsGet: string) {
    var response = await this.http.get<Document>(this.apiUrls.getPolicyGeneralCondition + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
  }

  extracData(id, policies) {
    var item;

    //FEXME
    policies.pipe().subscribe(items => {
      return items.filter(c => {
        if(c.IdDocumento == id) {
          return (item = c);
        }
      });
    });
        
    return item;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  
}